import React, { useContext, useEffect, useState } from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { BASE_URL_API } from '../../References/URLs';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import AuthContext from '../../store/auth-context';
import styles from './SecuritySetting.module.css';

const SecuritySetting = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [isUpdating, setIsUpdating] = useState(false)

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [loginAlerts, setLoginAlerts] = useState(true);
    const [sessionTimeout, setSessionTimeout] = useState('30');
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [isReadyToUpdate, setIsReadyToUpdate] = useState(false)

    const checkPasswordStrength = (password) => {
        let strength = 0;
        if (password.length >= 8) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/[0-9]/.test(password)) strength++;
        if (/[^A-Za-z0-9]/.test(password)) strength++;
        setPasswordStrength(strength);
    };

    const handleNewPasswordChange = (e) => {
        const password = e.target.value;
        setNewPassword(password);
        checkPasswordStrength(password);
    };

    const getStrengthClass = () => {
        if (passwordStrength <= 2) return styles.weak;
        if (passwordStrength <= 3) return styles.medium;
        return styles.strong;
    };

    const getStrengthText = () => {
        if (passwordStrength <= 2) return 'Weak';
        if (passwordStrength <= 3) return 'Medium';
        return 'Strong';
    };

    const recentActivities = [
        { action: 'Login from Chrome on Windows', time: '2 hours ago', location: 'New York, NY', status: 'success' },
        { action: 'Password changed', time: '1 day ago', location: 'New York, NY', status: 'success' },
        { action: 'Login attempt blocked', time: '3 days ago', location: 'Unknown', status: 'blocked' },
        { action: 'Two-factor authentication enabled', time: '1 week ago', location: 'New York, NY', status: 'success' },
    ];

    const activeSessions = [
        { device: 'Chrome on Windows', location: 'New York, NY', lastActive: 'Active now', current: true },
        { device: 'Safari on iPhone', location: 'New York, NY', lastActive: '2 hours ago', current: false },
        { device: 'Firefox on macOS', location: 'Boston, MA', lastActive: '1 day ago', current: false },
    ];

    const updatePasswordHandler = async () => {
        setIsUpdating(true)
        const response = await fetch(BASE_URL_API + "updatePassword",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    authIdentifier: authCtx?.authIdentifier,
                    currentPassword: currentPassword,
                    newPassword: newPassword,
                    newPasswordConfirm: confirmPassword
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server error!")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                toast(`Your passwords has been successfully updated. Please login again to continue!`)
                authCtx.logout()
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    if(respo?.message==="invalid current password!!") {
                        toast(`Invalid current password!`)
                    } else {
                        toast(`Something went wrong!`)
                    }
                }
            }
        }
        setIsUpdating(false)
    }

    useEffect(() => {
        const isValid =
            currentPassword?.trim() &&                // not empty
            newPassword?.trim() &&                    // not empty
            confirmPassword?.trim() &&                // not empty
            newPassword === confirmPassword &&        // match
            newPassword.length >= 5 &&                // strong enough (example rule)
            currentPassword !== newPassword;          // new is different from current

        setIsReadyToUpdate(Boolean(isValid));
    }, [currentPassword, newPassword, confirmPassword]);






    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        <div className={styles.mainHeader}>
                            Please select a store!
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.mainWrapper}>
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.title}>Security Settings</div>
                <div className={styles.subtitle}>Manage your account security and privacy settings for Lokaci Pro</div>
            </div>

            <div className={styles.bodyWrapper} >
                {/* Security Overview Cards */}
                {/* <div className={styles.overviewGrid}>
                    <div className={styles.overviewCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.iconShield}>🛡️</div>
                            <span className={`${styles.status} ${styles.active}`}>Active</span>
                        </div>
                        <h3 className={styles.cardTitle}>Account Protection</h3>
                        <p className={styles.cardDescription}>Your account is secured with strong password and 2FA</p>
                    </div>

                    <div className={styles.overviewCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.iconPhone}>📱</div>
                            <span className={`${styles.status} ${twoFactorEnabled ? styles.enabled : styles.disabled}`}>
                                {twoFactorEnabled ? 'Enabled' : 'Disabled'}
                            </span>
                        </div>
                        <h3 className={styles.cardTitle}>Two-Factor Auth</h3>
                        <p className={styles.cardDescription}>Add an extra layer of security to your account</p>
                    </div>

                    <div className={styles.overviewCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.iconUsers}>👥</div>
                            <span className={`${styles.status} ${styles.sessions}`}>3 Active</span>
                        </div>
                        <h3 className={styles.cardTitle}>Active Sessions</h3>
                        <p className={styles.cardDescription}>Manage your logged-in devices and locations</p>
                    </div>
                </div> */}

                <div className={styles.contentGrid}>
                    {/* Left Column */}
                    <div className={styles.leftColumn}>
                        {/* Change Password */}
                        <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconLock}>🔒</div>
                                <h2 className={styles.sectionTitle}>Change Password</h2>
                            </div>

                            <div className={styles.passwordForm}>
                                <div className={styles.inputGroup}>
                                    <label className={styles.label}>Current Password</label>
                                    <div className={styles.passwordInput}>
                                        <input
                                            type={showCurrentPassword ? 'text' : 'password'}
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                            className={styles.input}
                                            placeholder="Enter current password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                            className={styles.eyeButton}
                                        >
                                            {showCurrentPassword ? '👁️‍🗨️' : '👁️'}
                                        </button>
                                    </div>
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.label}>New Password</label>
                                    <div className={styles.passwordInput}>
                                        <input
                                            type={showNewPassword ? 'text' : 'password'}
                                            value={newPassword}
                                            onChange={handleNewPasswordChange}
                                            className={styles.input}
                                            placeholder="Enter new password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            className={styles.eyeButton}
                                        >
                                            {showNewPassword ? '👁️‍🗨️' : '👁️'}
                                        </button>
                                    </div>
                                    {newPassword && (
                                        <div className={styles.strengthMeter}>
                                            <div className={styles.strengthHeader}>
                                                <span>Password Strength:</span>
                                                <span className={getStrengthClass()}>{getStrengthText()}</span>
                                            </div>
                                            <div className={styles.strengthBar}>
                                                <div
                                                    className={`${styles.strengthFill} ${getStrengthClass()}`}
                                                    style={{ width: `${(passwordStrength / 5) * 100}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.label}>Confirm New Password</label>
                                    <div className={styles.passwordInput}>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className={styles.input}
                                            placeholder="Confirm new password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className={styles.eyeButton}
                                        >
                                            {showConfirmPassword ? '👁️‍🗨️' : '👁️'}
                                        </button>
                                    </div>
                                    {confirmPassword && newPassword !== confirmPassword && (
                                        <p className={styles.errorText}>Passwords do not match</p>
                                    )}
                                </div>

                                {isReadyToUpdate === false ? (
                                    <button className={styles.primaryButton} disabled={true} >
                                        Update Password
                                    </button>
                                )
                                    :
                                    <>
                                        {isUpdating === false ?
                                            <button className={styles.primaryButton} onClick={() => updatePasswordHandler()} >
                                                Update Password
                                            </button>
                                            :
                                            <button className={styles.primaryButtonLoader} onClick={() => updatePasswordHandler()} >
                                                <BiLoaderAlt size={18} className={styles.spinner} /> Updating Password...
                                            </button>
                                        }
                                    </>
                                }
                            </div>
                        </div>

                        {/* Two-Factor Authentication */}
                        {/* <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconPhone}>📱</div>
                                <h2 className={styles.sectionTitle}>Two-Factor Authentication</h2>
                                <div className={styles.toggle}>
                                    <input
                                        type="checkbox"
                                        checked={twoFactorEnabled}
                                        onChange={(e) => setTwoFactorEnabled(e.target.checked)}
                                        className={styles.checkbox}
                                        id="twoFactor"
                                    />
                                    <label htmlFor="twoFactor" className={styles.toggleLabel}>
                                        {twoFactorEnabled ? 'Enabled' : 'Disabled'}
                                    </label>
                                </div>
                            </div>

                            <p className={styles.description}>
                                Add an extra layer of security by requiring a verification code from your phone when signing in.
                            </p>

                            {twoFactorEnabled ? (
                                <div className={styles.twoFactorEnabled}>
                                    <div className={styles.successAlert}>
                                        <span className={styles.checkIcon}>✅</span>
                                        <span>Two-factor authentication is active</span>
                                    </div>
                                    <div className={styles.buttonGroup}>
                                        <button className={styles.secondaryButton}>View Backup Codes</button>
                                        <button className={styles.dangerButton}>Disable 2FA</button>
                                    </div>
                                </div>
                            ) : (
                                <button
                                    onClick={() => setTwoFactorEnabled(true)}
                                    className={styles.primaryButton}
                                >
                                    Enable Two-Factor Authentication
                                </button>
                            )}
                        </div> */}

                        {/* Security Preferences */}
                        {/* <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconSettings}>⚙️</div>
                                <h2 className={styles.sectionTitle}>Security Preferences</h2>
                            </div>

                            <div className={styles.preferences}>
                                <div className={styles.preferenceItem}>
                                    <div className={styles.preferenceInfo}>
                                        <h3 className={styles.preferenceTitle}>Email Security Notifications</h3>
                                        <p className={styles.preferenceDescription}>Get notified about important security events</p>
                                    </div>
                                    <input
                                        type="checkbox"
                                        checked={emailNotifications}
                                        onChange={(e) => setEmailNotifications(e.target.checked)}
                                        className={styles.checkbox}
                                    />
                                </div>

                                <div className={styles.preferenceItem}>
                                    <div className={styles.preferenceInfo}>
                                        <h3 className={styles.preferenceTitle}>Login Alerts</h3>
                                        <p className={styles.preferenceDescription}>Alert when someone logs into your account</p>
                                    </div>
                                    <input
                                        type="checkbox"
                                        checked={loginAlerts}
                                        onChange={(e) => setLoginAlerts(e.target.checked)}
                                        className={styles.checkbox}
                                    />
                                </div>

                                <div className={styles.inputGroup}>
                                    <label className={styles.label}>Session Timeout</label>
                                    <select
                                        value={sessionTimeout}
                                        onChange={(e) => setSessionTimeout(e.target.value)}
                                        className={styles.select}
                                    >
                                        <option value="15">15 minutes</option>
                                        <option value="30">30 minutes</option>
                                        <option value="60">1 hour</option>
                                        <option value="240">4 hours</option>
                                        <option value="480">8 hours</option>
                                    </select>
                                    <p className={styles.helpText}>Automatically log out after period of inactivity</p>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* Right Column */}
                    <div className={styles.rightColumn}>
                        {/* Recent Security Activity */}
                        {/* <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconClock}>🕐</div>
                                <h2 className={styles.sectionTitle}>Recent Security Activity</h2>
                            </div>

                            <div className={styles.activityList}>
                                {recentActivities.map((activity, index) => (
                                    <div key={index} className={styles.activityItem}>
                                        <div className={`${styles.statusDot} ${styles[activity.status]}`}></div>
                                        <div className={styles.activityContent}>
                                            <p className={styles.activityAction}>{activity.action}</p>
                                            <p className={styles.activityDetails}>{activity.location} • {activity.time}</p>
                                        </div>
                                        {activity.status === 'blocked' && (
                                            <div className={styles.warningIcon}>⚠️</div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <button className={styles.linkButton}>View All Activity</button>
                        </div> */}

                        {/* Active Sessions */}
                        {/* <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconUsers}>👥</div>
                                <h2 className={styles.sectionTitle}>Active Sessions</h2>
                            </div>

                            <div className={styles.sessionsList}>
                                {activeSessions.map((session, index) => (
                                    <div key={index} className={styles.sessionItem}>
                                        <div className={styles.sessionInfo}>
                                            <div className={styles.sessionDevice}>
                                                <span>{session.device}</span>
                                                {session.current && (
                                                    <span className={styles.currentBadge}>Current</span>
                                                )}
                                            </div>
                                            <p className={styles.sessionLocation}>{session.location}</p>
                                            <p className={styles.sessionTime}>{session.lastActive}</p>
                                        </div>
                                        {!session.current && (
                                            <button className={styles.logoutButton}>🚪</button>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <button className={styles.dangerButton}>
                                Sign Out All Other Sessions
                            </button>
                        </div> */}

                        {/* Account Recovery */}
                        {/* <div className={styles.card}>
                            <div className={styles.sectionHeader}>
                                <div className={styles.iconKey}>🔑</div>
                                <h2 className={styles.sectionTitle}>Account Recovery</h2>
                            </div>

                            <p className={styles.description}>
                                Set up recovery options in case you lose access to your account.
                            </p>

                            <div className={styles.recoveryOptions}>
                                <button className={styles.recoveryButton}>Add Recovery Email</button>
                                <button className={styles.recoveryButton}>Add Recovery Phone</button>
                                <button className={styles.recoveryButton}>Download Recovery Codes</button>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* Save Changes Button */}
                {/* <div className={styles.saveSection}>
                    <button className={styles.saveButton}>Save All Changes</button>
                </div> */}
            </div>
        </div>
    );
};

export default SecuritySetting;